import { render } from "./StandbyCheckEditor.vue?vue&type=template&id=52a10da2"
import script from "./StandbyCheckEditor.vue?vue&type=script&lang=ts"
export * from "./StandbyCheckEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script